<template>
  <div>
    <heads :more="showMore" :msg="title_msg" :states="1"></heads>
    <!-- <div class="ipt">
      <input v-model="code" type="text" placeholder="请输入您的身份证号或筑龙证书编号">
    </div>
    <div class="btn">
      <button @click="myserch()">立即查询</button>
    </div> -->
    <div v-if="certificateList.length>0" class="searchRes">
      <p class="searchTitle">
        <span>个人证书（{{ certificateList.length }}个）</span>
        <span>操作</span>
      </p>
      <p v-for="(item,index) in certificateList" :key="index" class="p_item">
        <span class="left_name">{{ item.certificate_name }}</span>
        <span class="check" @click.stop="check(item)">查看</span>
      </p>
    </div>
    <div v-else class="noDatas">
      <img src="@/assets/new_kong.png" alt>
      <p v-html="error_msg"></p>
    </div>

  </div>
</template>

<script>
import heads from '@/components/common/heads.vue'
import { getMyCertification } from '@/api/credential.js'
export default {
  components: {
    heads
  },
  data() {
    return {
      isshow: false,
      title_msg: '我的证书',
      code: '',
      isZsbh: false,
      showMore: false,
      msg: '请输入有效的身份证号或证书编号',
      error_msg: '没有查询到相关证书',
      certificateList: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      getMyCertification({}).then(res => {
        if (res.errNo === 0) {
          this.certificateList = res.result || []
        } else {
          if (res.errNo == 2001) {
            this.jumpLogin()
          } else {
            this.error_msg = res.msg || '没有查询到相关证书'
          }
        }
      })
    },
     // 去登录
    jumpLogin() {
      const url = decodeURIComponent(window.location.href)
      this.$router.push({
        path: '/login',
        query: {
          redirect: url
        }
      })
    },
    // 查看
    check(val) {
      window.location.href = val.url
      // this.$router.push({
      //   path: '/CertificateQueryLook',
      //   query: {
      //     id: val.id
      //   }
      // })
    },
    clicks() {
      if (this.isshow === false) {
        this.isshow = true
      } else {
        this.isshow = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.errmsg {
  color: #ee2e2e;
  padding: 15px 0 0 35px;
}
.btn {
  width: 100%;
  margin: 30px 0 0 0;
  button {
    background: #ee2e2e;
    color: #fff;
    height: 90px;
    line-height: 90px;
    width: 92%;
    display: block;
    margin: 0 auto;
    font-size: 32px;
  }
}
.img_h {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 30px;
  top: 58px;
  z-index: 1;
}
.ipt {
  width: 100%;
  margin: 50px 0 0 0;
  input {
    margin: 0 auto;
    display: block;
    width: 85%;
    height: 80px;
    border: 1px solid #d8d8d8;
    letter-spacing: 2px;
    padding: 0 0 0 50px;
    font-size: 26px;
  }
}
/deep/.van-dialog {
  border-radius: 6px;
}
p {
  margin: 0;
  padding: 0;
}
.searchRes{
  margin: 40px 40px;
  width: calc(100% - 80px);

  .searchTitle{
    font-size: 30px;
    font-weight: 800;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .p_item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    margin-bottom: 30px;
    padding-bottom: 35px;
    border-bottom: 1px solid #f5f5f5;
    .left_name {
      width: calc(100% - 80px);
    }
    .check{
      width:70px;
      display: inline-block;
      text-align: center;
      color:#ee2e2e;
      cursor:pointer;
    }
  }
}
.noDatas {
  margin-top: 50%;
  text-align: center;
  img {
    margin: 0 auto;
    width: 250px;
    height: 250px;
    display: block;
  }
  p {
    font-family: PingFangSC-Regular;
    margin-top: 20px;
    font-size: 24px;
    color: #333;
  }
}
</style>
